import { render, staticRenderFns } from "./About.vue?vue&type=template&id=8a96aad0&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=8a96aad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a96aad0",
  null
  
)

export default component.exports